import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { BreadCrumb } from "@/components/organisms/BreadCrumb";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";
import { OnstepCover } from "@/components/organisms/OnstepCover";
import { OnstepWhat } from "@/components/organisms/OnstepWhat";
import { OnstepOutline } from "@/components/organisms/OnstepOutline";
import OnstepCapabilities from "@/components/organisms/OnstepCapabilities";
import OnstepIntroduction from "@/components/organisms/OnstepIntroduction";
import { FadeInSection } from "@/components/molecules/FadeInSection";

export default function ProductSpeedCMSPage(props) {
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={"ONSTEP オンステップ"}
        pageDescription={
          "ファンマ（ファンマーケティング）を次のステージへ。物販も電子コンテンツも一元管理。ファンとのコミュニケーション、分析、収益化までをシームレスに繋ぐ多機能プラットフォーム"
        }
        pagePath={"https://tocca.systems/product/onstep/"}
      />
      <Layout>
        <Header isRelative={isHeaderRelative} />
        <main className="z-10 flex-1">
          <Container>
            <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Product",
                  path: "/product/",
                },
                {
                  name: "ONSTEP",
                },
              ]}
            />
            <Inner className="max-w-full pt-0 md:pt-5 ">
              <OnstepCover />
              <FadeInSection>
                <OnstepWhat />
              </FadeInSection>
              <FadeInSection delay={0.1}>
                <OnstepOutline />
              </FadeInSection>
              <FadeInSection delay={0.2}>
                <OnstepCapabilities />
              </FadeInSection>
              <FadeInSection delay={0.3}>
                <OnstepIntroduction />
              </FadeInSection>
            </Inner>
          </Container>
        </main>
        <Contact>
          ONSTEPはあなたのビジネスに役立てることができるツールです。
          <br />
          まずはお気軽にお問い合わせください。
        </Contact>
        <Careers />
        <Footer />
      </Layout>
    </>
  );
}
